// Options for the admin's Retell voice settings. These mirror the enums and
// ranges enforced in supabase/functions/_shared/retellConfig.ts
// (RETELL_VOICE_MODELS / RETELL_VOICE_EMOTIONS / applyRetellVoice); a value
// missing there is dropped at sync time, so keep the two in step.

export const RETELL_VOICE_MODEL_GROUPS = [
  { provider: 'Cartesia', models: ['sonic-3', 'sonic-3-latest', 'sonic-3.5', 'sonic-3.6'] },
  { provider: 'ElevenLabs', models: ['eleven_flash_v2', 'eleven_flash_v2_5', 'eleven_multilingual_v2', 'eleven_v3'] },
  { provider: 'OpenAI', models: ['tts-1', 'gpt-4o-mini-tts'] },
  { provider: 'MiniMax', models: ['speech-02-turbo', 'speech-2.8-turbo'] },
  { provider: 'Fish Audio', models: ['s1', 's2-pro', 's2.1-pro'] },
  { provider: 'Inworld', models: ['inworld-tts-2', 'inworld-tts-2-flash'] },
];

export const RETELL_VOICE_EMOTIONS = ['calm', 'sympathetic', 'happy', 'sad', 'angry', 'fearful', 'surprised'];

export const RETELL_VOICE_SPEED_RANGE = { min: 0.5, max: 2 };
export const RETELL_VOLUME_RANGE = { min: 0, max: 2 };
export const RETELL_VOICE_TEMPERATURE_RANGE = { min: 0, max: 2 };
